import { createAsyncThunk } from '@reduxjs/toolkit';
import { crosswordService } from '../../services/crossword.service';
export const getCrosswords = createAsyncThunk('crosswords/get', async ({ status }, { fulfillWithValue, rejectWithValue }) => {
    try {
        const crosswords = await crosswordService.getCrosswords({ status });
        return fulfillWithValue({ crosswords: [...crosswords] });
    }
    catch (error) {
        return rejectWithValue(error instanceof Error ? error.message : 'An unknown error occurred');
    }
});
export const createCrossword = createAsyncThunk('crosswords/create', async (crossword, { fulfillWithValue, rejectWithValue }) => {
    try {
        const createdCrossword = await crosswordService.createCrossword(crossword);
        return fulfillWithValue({ crossword: { ...createdCrossword } });
    }
    catch (error) {
        return rejectWithValue(error instanceof Error ? error.message : 'An unknown error occurred');
    }
});
export const getCrossword = createAsyncThunk('crosswords/getOne', async (crosswordId, { fulfillWithValue, rejectWithValue }) => {
    try {
        const crossword = await crosswordService.getCrosswordDetails(crosswordId);
        return fulfillWithValue({ crossword });
    }
    catch (error) {
        return rejectWithValue(error instanceof Error ? error.message : 'An unknown error occurred');
    }
});
export const updateCrossword = createAsyncThunk('crosswords/update', async ({ crosswordId, data, }, { fulfillWithValue, rejectWithValue }) => {
    try {
        const crossword = await crosswordService.updateCrossword(crosswordId, data);
        return fulfillWithValue(crossword);
    }
    catch (error) {
        return rejectWithValue(error instanceof Error ? error.message : 'An unknown error occurred');
    }
});
export const deleteCrossword = createAsyncThunk('crosswords/delete', async (crosswordId, { fulfillWithValue, rejectWithValue }) => {
    try {
        await crosswordService.deleteCrossword(crosswordId);
        return fulfillWithValue({ crosswordId });
    }
    catch (error) {
        return rejectWithValue(error instanceof Error ? error.message : 'An unknown error occurred');
    }
});
export const updateCrosswordStatus = createAsyncThunk('crosswords/publish', async ({ crosswordId, status, }, { fulfillWithValue, rejectWithValue }) => {
    try {
        const crossword = await crosswordService.updateCrosswordStatus(crosswordId, status);
        return fulfillWithValue(crossword);
    }
    catch (error) {
        return rejectWithValue(error instanceof Error ? error.message : 'An unknown error occurred');
    }
});
export const updateWords = createAsyncThunk('crosswords/updateWords', async ({ crosswordId, words, seed, }, { fulfillWithValue, rejectWithValue }) => {
    try {
        const data = await crosswordService.updateWords(crosswordId, words, seed);
        return fulfillWithValue(data);
    }
    catch (error) {
        return rejectWithValue(error instanceof Error ? error.message : 'An unknown error occurred');
    }
});
